import React from 'react';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import caretLeft from '../../../../../assets/icons/ic_caret_left.svg';
import MultipeCustomChannelCheckbox from '../../../common/MultipeCustomChannelCheckbox';
import { useBookingChannels } from '../../../../../utilities/hooks/useBookingChannels';

const SelectFilterChannel = (props) => {
	const dictionary = useDictionary();
	const bookingChannels = useBookingChannels();

	const backToFilterList = () => {
		props.setShowBoxFilter(true);
		props.setShowChannelSelectbox(false);
	};

	return (
		<div className="group-filter-hidden inputs">
			<a href="#" onClick={backToFilterList} className="back-to-filter-list">
				<img src={caretLeft} />
				<span>{dictionary.back}</span>
			</a>
			{Object.keys(bookingChannels).map((bookingChannel) => (
				<MultipeCustomChannelCheckbox
					label={bookingChannels[bookingChannel].text}
					checbboxObj={props.channelCheckeds}
					itemKey={bookingChannel}
					onFilterChannelSelected={props.onFilterChannelSelected}
					setEnableScheduling={props.setEnableScheduling}
					filterCount={props.filterCount}
					key={bookingChannels[bookingChannel].id}
				/>
			))}
		</div>
	);
};

SelectFilterChannel.propTypes = {
	setShowBoxFilter: PropTypes.func,
	setShowChannelSelectbox: PropTypes.func,
	setEnableScheduling: PropTypes.func,
	channelCheckeds: PropTypes.array,
	filterCount: PropTypes.number,
	onFilterChannelSelected: PropTypes.func
};

export default SelectFilterChannel;
